module.exports = __webpack_public_path__ + "img/redconfirmheader.8679464c.png";